import "./App.css";
import Body from "./body";
import axios from "axios";
import React from "react";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      channelInfo: [],
    };
  }

  componentDidMount() {
    this.getChannelInfo();
  }

  getChannelInfo() {
    let channelInfo = [];
    axios
      .get(
        "https://api.rlaxxtv.com/api/channels?api_token=$2y$10$R/FhLThrJDzf8QZdaIItZeim/3N2.1f2g9IFDmJTpj0owG21GtPma"
      )
      .then((response) => {
        for (const channel in response.data) {
          let currentEPG = {};
          if ("SportRadar" in response.data[channel].externalData) {
            if (
              "epg" in response.data[channel].externalData.SportRadar.apiData
            ) {
              currentEPG =
                response.data[channel].externalData.SportRadar.apiData.epg;
            } else {
              currentEPG =
                response.data[channel].externalData.SportRadar.apiData
                  .categories;
            }
          } else if ("Vevo" in response.data[channel].externalData) {
            currentEPG = response.data[channel].externalData.Vevo.apiData.epg;
          } else if ("Pantaflix" in response.data[channel].externalData) {
            currentEPG =
              response.data[channel].externalData.Pantaflix.apiData.epg;
          } else {
            console.log("Not found");
          }

          channelInfo.push({
            id: response.data[channel].id,
            title: response.data[channel].title,
            epg: currentEPG,
          });
        }

        const sortedChannelInfo = channelInfo.sort(function (a, b) {
          let keyA = a.title.toUpperCase();
          let keyB = b.title.toUpperCase();
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });

        this.setState({
          channelInfo: sortedChannelInfo,
          isFetching: true,
        });
      })
      .catch((error) => console.error(error));
  }

  render() {
    const { channelInfo } = this.state;
    if (channelInfo.length === 0) return null;
    return (
      <div className="App">
        <Body channelInfo={channelInfo} />
      </div>
    );
  }
}

export default App;
